//Core modules
import React, {Fragment, useEffect, useState} from 'react';
import Switch from "react-switch";

//External modules
import Tabs from 'react-responsive-tabs';
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

//Internal modules.
import requestApi from "../../../services/requestApi.service";
import {handleErrorResponse,getServerDomainURL,showToast,confirmBoxWithImage} from "../../../Common/Appcommon";
import TableList from '../../../Common/TableList';
import FieldsMapping from '../../../Common/FieldsMapping';
import LegacyGoogleAdsLog from '../GoogleAds/GoogleAdsLog';
const Webhooks = (props) => {

    const [adForms, setAdForms] = useState({});
    const [showMapping, setShowMapping] = useState(false);
    const [showViewLog, setShowViewLog] = useState(false);
    const [adFormInfo, setAdFormInfo] = useState({});
    const [formFilDefault, setFormFilDefault] = useState({});
    const [webhookurl, setWebhookUrl] = useState("");
    const [formFilterOptions, setFormFilterOptions] = useState({});
    const [webhookName, setWebhookName] = useState("");
    const [randomid, setRandomId] = useState("");
    const [listfieldsname,setListFieldsName] = useState([['name','form id','module','Last Updated','Edit','View Log','Delete','ON/OFF'],['6','3','2','5','0','-1','-2','-3']])
    const formName = process.env.REACT_APP_GOOGLEADSLOG_FORMNAME;

    useEffect(() => {
        (async () => {
            await getFormsList();
        })();
    },[]);

    const getFormsList = async () => {
        setShowViewLog(false);
        let params = {
            "ENTITY": "WEBHOOKSLEADSPROCESS",
            "OPERATION" : 'GETALL'
        }
        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            setAdForms(response.data);
        }else{
            handleErrorResponse(response.errormsg);
        }
    }

    const processAddInfo = async () => {
        const baseUrl = getServerDomainURL();
        const webhookUrl = baseUrl+"/Customize/Webhooks/webhook.php";
        let params = {
            "ENTITY" : "WEBHOOKSLEADSPROCESS",
            "OPERATION" : "UPDATE_FIELDPAYLOAD_DETAILS",
            "randomid" : Math.floor((Math.random()*1000000)+1),
            "url" : webhookUrl
        }
        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            setAdFormInfo(response.data[0]);
            await getFormsList();
            await ShowEditScreen(response.data[0]);

        }else{
            handleErrorResponse(response.errormsg);
        }
    }

    const ShowEditScreen = async (formData) => {
        setShowViewLog(false);
        setAdFormInfo(formData);
        setShowMapping(true);
        let formname = formData[2];
        if(formname === "" || formname === undefined){
            formname = "Leads";
        }
        setFormFilDefault({value: formname, label: formname});
        setWebhookName(formData[6]);
        setWebhookUrl("Customize/Webhooks/webhook.php?id="+formData[3]);
        let params = {
            "ENTITY": "WEBHOOKSLEADSPROCESS",
            "OPERATION" : 'GET_FORMFILTERFIELDS'
        }
        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            let fields = [];
            let dfields = response.data;
            for(let i=0; i< dfields.length;i++){
                const label = dfields[i][0] !== undefined ? dfields[i][0] : "";
                fields.push({
                    value: label, label: label
                })
            }
            setFormFilterOptions(fields);
            
        }else{
            handleErrorResponse(response.errormsg);
        }
    }

    const ShowViewLogScreen = async (formData) => {
        setShowViewLog(true);
        setShowMapping(false);
        setRandomId(formData[3]);
    }

    const onBackAction = async () => {
        setShowViewLog(false);
        setShowMapping(false);
        setAdFormInfo({});
        await getFormsList();

    }

    const deletewebhookpopup = async (formData) => {
        let isDelete = await confirmBoxWithImage("Delete Webhook","Are you sure you want to delete this webhook?",'',"OK","Cancel","","",false,false,false);
        if(isDelete){
            let params = {
                "ENTITY": "WEBHOOKSLEADSPROCESS",
                "OPERATION" : 'DELETE_WEBHOOK',
                "UNIQUEID" : formData[3],
                "MAPPINGID" : formData[0]
            }
            let response = await requestApi.processServerRequest(params);
            if(response.issuccess){
                await getFormsList();
                showToast(`Deleted successfully.`);
            }
        }
    }

    const handleCheckboxChange = async (e,formData) => {
        if(formData[7] == 'inactive' ){
                let params = {
                    "ENTITY": "WEBHOOKSLEADSPROCESS",
                    "OPERATION" : 'PAUSE_WEBHOOK',
                    "UNIQUEID" : formData[3],
                    "ISPAUSED" : "active"
                }
                let response = await requestApi.processServerRequest(params);
                if(response.issuccess){
                    await getFormsList();
                    showToast(`Webhook activated successfully.`);
                }
        }else{
            let isPaused = await confirmBoxWithImage("Pause Webhook","Are you sure you want to pause this webhook?",'',"OK","Cancel","","",false,false,false);
            if(isPaused){
            let params = {
                "ENTITY": "WEBHOOKSLEADSPROCESS",
                "OPERATION" : 'PAUSE_WEBHOOK',
                "UNIQUEID" : formData[3],
                "ISPAUSED" : "inactive"
            }
            let response = await requestApi.processServerRequest(params);
            if(response.issuccess){
                await getFormsList();
                 showToast(`Webhook paused successfully.`,`top-right`,`info`);
            }
        }
        }
    }

    const renderElements = (name,formData,field) => {
        if(name === 'editform'){
            return <div className={`le-clickable`} onClick={()=>{ShowEditScreen(formData)}}>{`EDIT`}</div>
        }else if(name === 'viewlog'){
            return <div className={`le-clickable`} onClick={()=>{ShowViewLogScreen(formData)}}>{`VIEW`}</div>
        } else if(name === 'deletewebhook'){
            return <div className={`le-clickable`} onClick={()=>{deletewebhookpopup(formData)}}>{`DELETE`}</div>
        } else if(name === 'pausewebhook'){
            return <div className={`pr-5`}><Switch onColor={"#23ae73"}  checked={formData[7] == 'active' ? true : false} onChange={(e) => {handleCheckboxChange(e,formData);}}/></div>
        }
    }

    return (
        <Fragment>
            {
               !showMapping &&  !showViewLog &&
               <div className='px-4'>
                    <button  className="add-autoreply-intent mt-6 float-right"  onClick={(e) => {processAddInfo(e)}} ><FontAwesomeIcon icon={faPlus} className={`mr-1`}/>Create Webhook</button>
               </div>            
            }
            {
                !showMapping && !showViewLog &&
                <TableList
                    onBackAction={props.onBackAction}
                    adForms={adForms}
                    renderElements={renderElements}
                    webhookform={"Customize/Webhooks/webhook.php"}
                    titlename={"Connected Webhooks"}
                    listfieldsname={listfieldsname}
                    screen ={"webhooks"}
                /> 
                
            }

            {
                showMapping &&
                <FieldsMapping
                    showMapping={showMapping}
                    formInfo={adFormInfo}
                    onBackAction={onBackAction}
                    screen ={"webhooks"}
                    mappingCol = ""
                    leadstatus = "active"
                    formfildefault = {formFilDefault}
                    webhookurl ={webhookurl}
                    formFilterOptions = {formFilterOptions}
                    webhookNameVal = {webhookName}
                />
            }
            {
                 showViewLog && !showMapping &&
                <Tabs
                    tabsWrapperClass="webhookvlgoback"//body-tabs body-tabs-layout header-tab-padding
                    transform={true}
                    showInkBar={false}
                    items={[
                    {
                        title: '',
                        content: <LegacyGoogleAdsLog onBackAction={onBackAction} integratedType="webhooks" webhookid={randomid}/>,
                        groupname : "legacy"
                    }
                    ]}
                />
            }
        </Fragment>
    );
}

export default Webhooks;
